
import { Route,  Routes } from 'react-router-dom';
import './App.css';
import { HomePage } from './Components/HomePage';
import AdmissionForm from './Components/AdmissionForm';
import AcademicInfo from './Components/AcademicInfo'
import EmployementInfo from './Components/EmploymentInfo';
import RegisterInfo from './Components/RegisterInfo';
import TermsAndCondition from './Components/Terms&conditions';
// import Progress from './Components/Progress';
import Header from './Components/Header';
import Login from './Components/Admin/Login';
import Register from './Components/Admin/Register';
import AdminDashboard from './Components/Admin/AdminDashboard';
import MultiStepForm from './Components/MultiStepForm';
import { useContext } from 'react';
import { FormContext } from './Components/Provider';
import AdminHeader from './Components/Admin/AdminHeader';
// import EditPersonal from './Components/Admin/EditPersonal';
import AdminSteps from './Components/Admin/AdminSteps';
import NotFound from './Components/NotFound';


function App() {
  const { Auth } = useContext(FormContext);
  return (
    <div>

      {/* <EmployementInfo/> */}
      {/* <RegisterInfo /> */}
      {/* <AcademicInfo /> */}
      {/* <TermsAndCondition/> */}
      {/* <AdmissionForm/> */}
      {/* <EmployementInfo/> */}
      {/* <RegisterInfo/> */}

      {/* <EmployementInfo /> */}
      {/* <RegisterInfo/> */}

      <div>

        
        {Auth ? <AdminHeader /> : <Header />}

        <Routes>
          <Route path='/' Component={HomePage} />

          <Route path='/personal-information' Component={AdmissionForm} />
          <Route path='/academic-information' Component={AcademicInfo} />
          <Route path='/employee-information' Component={EmployementInfo} />
          <Route path='/Register-information' Component={RegisterInfo} />
          <Route path='/termconditions' Component={TermsAndCondition} />

          <Route path="/admission-form" element={<MultiStepForm />} />
          {/* Admin Page  */}
          <Route path='/admin/login' element={Auth ? <AdminDashboard /> : <Login />} />
          <Route path='/admin/register' Component={Register} />
          <Route path='/admin/dashboard' Component={AdminDashboard} />
          {
            Auth &&
            (
              <Route path="/admin-forms/:id" element={<AdminSteps />} />
            )
          }
          <Route path='*' element={<NotFound />} />
        </Routes>
      </div>

    </div>
  );
}

export default App;
